// theme.js
import { createTheme } from '@mui/material/styles';

const getTheme = () => {
  const prefersDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  return createTheme({
    palette: {
      mode: prefersDarkMode ? 'dark' : 'light',
      primary: {
        main: '#698064',
        contrastText: '#fff',
      },
      secondary: {
        main: prefersDarkMode ? '#81c784' : '#4caf50',
        contrastText: '#fff',
      },
      info: {
        main: prefersDarkMode ? '#64b5f6' : '#2196f3',
        contrastText: '#fff',
      },
      text: {
        primary: prefersDarkMode ? '#ffffff' : '#230b01',
        secondary: prefersDarkMode ? '#b0b0b0' : '#666666',
      },
      background: {
        default: prefersDarkMode ? '#121212' : '#ffffff',
        paper: prefersDarkMode ? '#1e1e1e' : '#fff',
      },
      // Custom link colors
      link: {
        main: prefersDarkMode ? '#90caf9' : '#1976d2',
        hover: prefersDarkMode ? '#bbdefb' : '#1565c0',
      },
    },
  });

};

export default getTheme;